import { Component, OnInit } from "@angular/core";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  PageViewModel,
  SectionTypeNameEnum,
  SectionViewModel,
} from "src/domain/client";
import { BrandService } from "src/services/brand.service";
import { ErrorReporterService } from "src/services/error-reporter.service";
import { PageService } from "src/services/page.service";

@Component({
  selector: "vw-terms-page",
  templateUrl: "./terms-page.component.html",
})
export class TermsPageComponent implements OnInit {
  page?: PageViewModel;
  termSections: SectionViewModel[] = [];

  mediaCategoryTypeNames = MediaCategoryTypeNameEnum;
  mediaTypes = MediaTypeNameEnum;

  constructor(
    private pageService: PageService,
    private errorReporter: ErrorReporterService,
    private brandService: BrandService,
  ) {}

  ngOnInit(): void {
    this.getTermsPage();
  }

  //////////

  private getTermsPage(): void {
    this.pageService
      .getTermsPage(this.brandService.brandId)
      .then((page) => {
        this.page = page;

        this.termSections =
          page.sections?.filter(
            (_) => _.sectionTypeName === SectionTypeNameEnum.Term,
          ) ?? [];
      })
      .catch(this.errorReporter.handle);
  }
}
